// This file is generated by a script. Do not edit this file directly.
(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "react", "class-variance-authority", "../../components/Icon", "../utils", "../../components/Typography/Base"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("react"), require("class-variance-authority"), require("../../components/Icon"), require("../utils"), require("../../components/Typography/Base"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react, global.classVarianceAuthority, global.Icon, global.utils, global.Base);
    global.ChoiceGroupLayout = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _react, _classVarianceAuthority, _Icon, _utils, _Base) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.ChoiceGroupLayout = _exports.ChoiceGroupDirection = _exports.ChoiceGroupColumns = void 0;
  _react = _interopRequireDefault(_react);
  function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
  function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
  function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  var ChoiceGroupDirection = _exports.ChoiceGroupDirection = /*#__PURE__*/function (ChoiceGroupDirection) {
    ChoiceGroupDirection["VERTICAL"] = "vertical";
    ChoiceGroupDirection["HORIZONTAL"] = "horizontal";
    return ChoiceGroupDirection;
  }({});
  var ChoiceGroupColumns = _exports.ChoiceGroupColumns = /*#__PURE__*/function (ChoiceGroupColumns) {
    ChoiceGroupColumns["SingleCol"] = "single-column";
    ChoiceGroupColumns["TwoCol"] = "two-column";
    return ChoiceGroupColumns;
  }({});
  var groupDirection = (0, _classVarianceAuthority.cva)('cop-flex cop-mt-2', {
    variants: {
      direction: _defineProperty(_defineProperty({}, ChoiceGroupDirection.VERTICAL, 'cop-flex-col cop-gap-2'), ChoiceGroupDirection.HORIZONTAL, 'cop-flex-row cop-gap-4')
    },
    defaultVariants: {
      direction: ChoiceGroupDirection.VERTICAL
    }
  });
  var groupLayout = (0, _classVarianceAuthority.cva)('cop-flex', {
    variants: {
      layout: _defineProperty(_defineProperty({}, ChoiceGroupColumns.SingleCol, 'cop-flex-col'), ChoiceGroupColumns.TwoCol, 'cop-flex-row cop-gap-8')
    },
    defaultVariants: {
      layout: ChoiceGroupColumns.SingleCol
    }
  });
  var ChoiceGroupLayout = _exports.ChoiceGroupLayout = function ChoiceGroupLayout(_ref) {
    var label = _ref.label,
      description = _ref.description,
      error = _ref.error,
      helperText = _ref.helperText,
      _ref$direction = _ref.direction,
      direction = _ref$direction === void 0 ? ChoiceGroupDirection.VERTICAL : _ref$direction,
      _ref$layout = _ref.layout,
      layout = _ref$layout === void 0 ? ChoiceGroupColumns.SingleCol : _ref$layout,
      children = _ref.children,
      className = _ref.className,
      tooltipProps = _ref.tooltipProps;
    var isSingleColLayout = layout === ChoiceGroupColumns.SingleCol;
    var helperTextRenderer = helperText ? /*#__PURE__*/_react["default"].createElement("div", {
      className: "cop-text-secondary"
    }, /*#__PURE__*/_react["default"].createElement(_Base.Base, {
      variant: "body",
      size: "sm",
      leading: "normal",
      tag: "span",
      weight: "regular"
    }, helperText)) : null;
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _utils.cn)(className, groupLayout({
        layout: layout
      }))
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "cop-flex cop-justify-between cop-gap-2"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "cop-flex cop-flex-col"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "cop-flex cop-gap-1"
    }, /*#__PURE__*/_react["default"].createElement(_Base.Base, {
      variant: "body",
      size: "base",
      leading: "tight",
      tag: "span",
      weight: "medium"
    }, label), tooltipProps && /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_Icon.Icon, {
      icon: "Info",
      className: "cop-text-text-primary cop-h-3 cop-w-3"
    }))), description && /*#__PURE__*/_react["default"].createElement("div", {
      className: "cop-mt-0.5 cop-text-secondary"
    }, /*#__PURE__*/_react["default"].createElement(_Base.Base, {
      variant: "body",
      size: "sm",
      leading: "normal",
      tag: "span",
      weight: "regular"
    }, description))), isSingleColLayout && helperTextRenderer), /*#__PURE__*/_react["default"].createElement("div", null, !isSingleColLayout && helperTextRenderer, /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _utils.cn)(groupDirection({
        direction: direction
      }))
    }, children), error && /*#__PURE__*/_react["default"].createElement("div", {
      className: "cop-mt-2.5 cop-flex cop-items-center cop-gap-1 cop-text-[#cc0000]"
    }, /*#__PURE__*/_react["default"].createElement(_Icon.Icon, {
      icon: "Alert",
      className: "cop-h-3 cop-w-3"
    }), /*#__PURE__*/_react["default"].createElement(_Base.Base, {
      variant: "body",
      size: "base",
      leading: "normal",
      tag: "span",
      weight: "regular"
    }, error))));
  };
});
